import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetFinanceServicesFinancetypesService } from "@/features/accounts/finance/services/get-services-financetypes-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";


export const useGetFinanceServicesFinancetypes = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  const { setFinanceTypes } = useInstitutionsContext();

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getFinanceServicesFinancetypesService = new GetFinanceServicesFinancetypesService();

  /*--------------------
    イベント関連
  --------------------*/
  // 銀行口座種別取得
  const getFinanceServicesFinancetypes = async (
    industryCode: string,
    companyCode: string,
    serviceCode: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getFinanceServicesFinancetypesService.getFinanceServicesFinancetypes({
        industry_code: industryCode,
        company_code: companyCode,
        service_code: serviceCode,
      });
      setFinanceTypes(res);
    } catch (error) {
      // エラーハンドリング
      console.log("getFinanceServicesFinancetypes:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getFinanceServicesFinancetypes: errorHandledAsync(getFinanceServicesFinancetypes, setError),
  };
};
